import { useTier } from './useTier';

// Create namespaced logger for this hook
// Note: We use useTier internally now, so logging is handled there
/**
 * 100% RELIABLE subscription hook for paywall enforcement
 * 
 * This hook is designed to be the single source of truth for determining
 * if a user has access to premium content. It performs strict validation
 * to ensure no unauthorized access and no false negatives for paying users.
 * 
 * NOTE: This hook now uses the tier system internally. It returns true for
 * any paid tier (basic, pro, elite) to maintain backward compatibility.
 * 
 * @returns {Object} Returns:
 *   - isSubscribed: Boolean - true if user has valid active subscription (any paid tier), false otherwise
 *   - loading: Boolean - true while checking subscription status
 *   - error: String|null - error message if subscription check failed
 * 
 * @example
 * const { isSubscribed, loading } = useIsSubscribed();
 * if (loading) return <Loading />;
 * if (!isSubscribed) return <Paywall />;
 * return <PremiumContent />;
 */
export const useIsSubscribed = () => {
  const { tierId, loading, error } = useTier();

  // Calculate isSubscribed based on tier
  // Returns true for any paid tier (basic, pro, elite) to maintain backward compatibility
  const isSubscribed = tierId !== 'free' && tierId !== null;

  return {
    isSubscribed,
    loading,
    error,
  };
};

export default useIsSubscribed;

